import { ref, readonly } from "vue";

export type NotificationType = "success" | "warning" | "error";

export interface Notification {
    id: string;
    message: string;
    type: NotificationType;
}

const AUTO_DISMISS_MS = 5000;

const notifications = ref<Notification[]>([]);
let nextId = 0;

function addNotification(message: string, type: NotificationType): string {
    const id = `notification-${++nextId}`;
    notifications.value.push({ id, message, type });

    setTimeout(() => {
        removeNotification(id);
    }, AUTO_DISMISS_MS);

    return id;
}

function removeNotification(id: string): void {
    const index = notifications.value.findIndex(n => n.id === id);
    if (index !== -1) {
        notifications.value.splice(index, 1);
    }
}

function clearAll(): void {
    notifications.value.splice(0, notifications.value.length);
}

export function useNotificationStore() {
    return {
        notifications: readonly(notifications),
        addNotification,
        removeNotification,
        clearAll
    };
}
